import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-air',
  templateUrl: './magic-uses-air.component.html',
  styleUrls: ['./magic-uses-air.component.css']
})
export class MagicUsesAirComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
